<i18n src="./locales.json"></i18n>
<template>
  <v-container class="backgroundWhite pb-4">
    <div class="fullHeight">
      <v-row v-if="isLoading"> loading </v-row>
      <v-row v-else class="mt-4 pb-4 mb-4">
        <v-col cols="12" class="text-h2 font-weight-bold text-center">
          {{ $t('L_you_have_successfully_signed_out') }}
        </v-col>
        <v-col cols="12" class="ml-4 mr-4 text-center">
          <img
            class="imageDimension"
            src="@/modules/login/assets/SignOutPerson.png"
            alt="Signing out"
          />
        </v-col>
        <v-col cols="12" class="mb-4 pb-4 putAtBottomCenterHorizontally">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn @click="login" color="primary" class="mb-4">
                {{ $t('L_go_back_to_sign_in') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'PostLogout',
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async login() {
      this.isLoading = true;
      try {
        await this.$auth.login();
        // in iOS, the context returns here
        await this.$router.push({ name: RouteNames.DASHBOARD });
      } catch (err) {
        try {
          this.$dynatrace.reportCustomError(
            'PC2_MOBILE_ERR',
            `[PostLogoutPorch - Login failed]: ${JSON.stringify(err)}`
          );
        } catch (_) {
          /*  */
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.backgroundWhite {
  background-color: white;
}
.imageDimension {
  width: 80%;
  max-width: 300px;
}
.fullHeight {
  height: 100vh;
  position: relative;
}
.putAtBottomCenterHorizontally {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
</style>
